// extracted by mini-css-extract-plugin
export default {"container":"style_container__SHYl0","headerTitle":"style_headerTitle__EPlhF"};